import { TuiButtonModule } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  templateUrl: './global-error-page.component.html',
  styleUrls: [ './global-error-page.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TuiButtonModule,
  ],
})
export class GlobalErrorPageComponent {
  public reload(): void {
    document.location.reload();
  }
}
